export function appendSearchParamToAnyString(urlLike: string, key: string, value: string) {
	const split = urlLike.split('?');
	const searchParams = new URLSearchParams(split[1] ?? '');

	searchParams.set(key, value);

	return `${split[0]}?${searchParams.toString()}`;
}
